// extracted by mini-css-extract-plugin
module.exports = {"contactForm":"ContactPage_contactForm__3K9XI","instructions":"ContactPage_instructions__1N3q0","feedback":"ContactPage_feedback__GG0IJ","links":"ContactPage_links__nw4kR"};